import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Alert } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

function getStyle() {
  return {
    warning: {
      maxWidth: '994px',
      "& div[variant='warning']": {
        'margin-top': '10px',
        'background-color': '#feeda275',
        'border-color': '#feeda275',
      },
    },
  };
}

// eslint-disable-next-line
Warning.propTypes = {
  messages: PropTypes.objectOf(PropTypes.string).isRequired,
  classes: PropTypes.shape({}).isRequired,
};

function Warning({ messages, classes }) {
  const compactMessages = _.compact(messages);

  const alerts = _.map(compactMessages, msg => (
    <Alert key={msg} variant="warning">
      {msg}
    </Alert>
  ));


  return (
    <div className={classes.warning} id="createReportWarnings">
      {alerts}
    </div>
  );
}

const Wrapped = withDefaultStyles(Warning, getStyle);
export { Wrapped as Warning };
